import postsServices from "./postsService";
import notificationsServices from "./notificationService";
import userProfileServices from "./userProfileService";
import authServices from "./authService";
import documentsServices from "./documentService";
import chatServices from "./chatService";
import losServices from "./losService";
import supportService from "./supportService";

const service = {
  auth: authServices,
  posts: postsServices,
  notifications: notificationsServices,
  profile: userProfileServices,
  docs: documentsServices,
  chat: chatServices,
  los: losServices,
  support: supportService,
};

export default service;
